export default {
  en: {
    visitSiteLabel: 'Visit Site',
    // Email Signup
    emailAddress: 'Email Address',
    // Email Signup Privacy Policy
    emailProviding: 'By providing your email, you agree to our',
    protectedBy: 'This site is protected by reCAPTCHA and the Google',
    privacyPolicy: 'Privacy Policy',
    and: 'and',
    termsOfService: 'Terms of Service',
    apply: 'apply.',
    signUp: 'Sign Up',
    // Email Signup step 2:
    signedUpFor: 'Signed up for the',
    completeSignUp: 'Complete your sign-up',
    aboutYou: 'About you',
    companyName: 'Company Name',
    select: 'Select',
    chooseSubscriptions: 'Choose your subscriptions',
    thankYou: 'Thank you for subscribing!',
    startReceiving: 'You should start receiving your subscription in the next 24 hours along with a special welcome from the experts at',
    // Comments
    viewAllComments: 'View All Comments',
  },
  es: {
    visitSiteLabel: 'Visite el sitio',
    // Email Signup
    emailAddress: 'Correo Electrónico',
    // Email Signup Privacy Policy
    emailProviding: 'Al darnos su correo electrónico usted acepta nuestra',
    protectedBy: 'Este sitio está protegido por reCAPTCHA y por la Política de Privacidad de Google',
    privacyPolicy: 'Política de Privacidad',
    and: 'y',
    termsOfService: 'Términos del Servicio.',
    apply: 'aplican.',
    signUp: 'Suscríbase',
    // Email Signup step 2:
    signedUpFor: 'Suscrito para',
    completeSignUp: 'Llene su suscripción',
    aboutYou: 'Acerca de usted',
    companyName: 'Nombre de compañía',
    select: 'Seleccione',
    chooseSubscriptions: 'Elija sus suscripciones',
    thankYou: '¡Gracias por suscribirse!',
    startReceiving: 'Usted debería comenzar a recibir su suscripción en las próximas 24 horas, junto con una bienvenida especial de los expertos en',
    // Comments
    viewAllComments: 'Vea todos los comentarios',
  },
  pt: {
    visitSiteLabel: 'Visite o site',
    emailAddress: 'E-mail',
    viewAllComments: 'Veja todos os comentários',
  },
};
